var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({'overflow-x': _vm.overflow})},[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"},on:{"after-leave":_vm.enter}},[_c('router-view',{key:_vm.$route.params.id})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }